<template>
  <div>
    <nuttrema-iconica-sidebar-link :icon="icon" :title="title" @click="toggleOverlay" :theme="theme" :picture="pictureBackgroundImage"></nuttrema-iconica-sidebar-link>

    <nuttrema-dialog
    :visible.sync="show"
    :append-to-body="true">
    <nuttrema-layout-west-slide v-if="show" :width="width" :minWidth="minWidth" theme="transparent">
      <west-slide-left-navigation slot="navigation-top">
        <a @click="closeOverlay" :title="$t('label.close')">
          <nuttrema-iconica-sidebar-link icon="far fa-times" theme="white"></nuttrema-iconica-sidebar-link>
        </a>
      </west-slide-left-navigation>
      <overlay-page @close="closeOverlay"></overlay-page>
    </nuttrema-layout-west-slide>
  </nuttrema-dialog>
  </div>
</template>

<script>
import { get } from 'lodash';
import { getPersonIcon } from 'utils/person';

import NuttremaDialog from 'components/ui/overlay/nuttrema-dialog';

import NuttremaLayoutWestSlide from 'components/ui/layout/nuttrema-layout-west-slide';

import NuttremaLayoutEastBlock from 'components/ui/layout/nuttrema-layout-east-block';
import NuttremaLayoutWestThreeVertical from 'components/ui/layout/nuttrema-layout-west-three-vertical';

import WestSlideLeftNavigation from 'components/ui/west-slide-component/west-slide-left-navigation';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

import OverlayPage from './cmpt-dummy-overlay';

export default {
  name: 'nuttrema-overlay-help-button',
  components: {
    OverlayPage,
    WestSlideLeftNavigation,
    NuttremaLayoutEastBlock,
    NuttremaLayoutWestSlide,
    NuttremaIconicaSidebarLink,
    NuttremaLayoutWestThreeVertical,
    NuttremaDialog,
  },
  props: {
    theme: {
      type: String,
      required: false,
      default: null,
    },
    title: {
      type: String,
      required: false,
      default: null,
    },
    width: {
      type: String,
      required: false,
      default: '25%',
    },
    minWidth: {
      type: String,
      required: false,
      default: '35em',
    },
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    PersonalProfile() {
      return this.$store.getters.PersonalProfile;
    },
    icon() {
      return getPersonIcon(this.PersonalProfile);
    },
    pictureBackgroundImage() {
      const path = get(this.PersonalProfile, 'data.ProfilePicture.path', '');
      const picture = get(this.PersonalProfile, 'data.ProfilePicture.thumbnails.large.filename', '');
      return `${process.env.IMAGES_ROOT}${path}${picture}`;
    },
  },
  methods: {
    toggleOverlay() {
      this.$nextTick(() => {
        this.show = !this.show;
      });
    },
    closeOverlay() {
      this.$nextTick(() => {
        this.show = false;
      });
    },
  },
  created() {
    this.$store.dispatch('GetPersonalProfile');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/overlay/nuttrema-overlay-sidebar-link.vue